import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import ecommerce from "../../Assets/Projects/e-commerce.png";
import chatvideo from "../../Assets/Projects/video-chat.png";
import dictionnary from "../../Assets/Projects/dictionnary.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          <strong className="brown">Mes projets </strong>récents
        </h1>
        <p style={{ color: "white" }}>
          Ces sont les projets que j'ai réalisés récement
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatvideo}
              isBlog={false}
              title="Chat Vidéo"
              description="Ce projet personnel vise à offrir aux utilisateurs un accès gratuit à une plateforme de chat vidéo, adaptée tant à un usage personnel que professionnel."
              ghLink="https://github.com/Laurent3898/free-chat-video"
              demoLink="https://free-chat-video.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dictionnary}
              isBlog={false}
              title="Dictionnaire"
              description="Une application web conçue pour aider les utilisateurs à utiliser un dictionnaire anglais en ligne directement dans leur navigateur."
              ghLink="https://github.com/Laurent3898/online-dictionnary"
              demoLink="https://online-dictionnary.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ecommerce}
              isBlog={false}
              title="Marketplace"
              description="Une plateforme e-commerce conçue pour simplifier l'achat de produits en ligne, offrant aux utilisateurs la possibilité de faire leurs achats directement depuis chez eux."
              ghLink="https://github.com/Laurent3898/e-technology"
              demoLink="https://e-technology.vercel.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
